<template>
  <div class="llp">
    <div class="slide-one">
      <div class="content-center">
        <div class="title">合作伙伴招募</div>
        <div class="btn-warp">
          <div class="btn" @click="addLLP">我想加入LLP</div>
          <div>
            <div class="p-warp">
              <div class="p-bg"></div>
              <div class="p">货拉拉·LaLaPartner简称LLP</div>
              <div class="p">
                是货拉拉汽车销售及司机管理的重要业务组成单元。作为平台跟行业内合作伙伴建立连接的入口，
                我们期待更多伙伴的加入，建立长期合作关系，依托城市本地资源，共同开拓各地车辆销售业务，最终实现互利共赢。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-center">
      <div class="title-box">
        <div class="title">LLP发展历程</div>
      </div>
      <el-row :gutter="40">
        <el-col :span="8">
          <div class="progress">
            <div class="progress-title">落地30+城市</div>
            <div class="progress-p">
              以车队模式切入，独立于平台个体司机， 打造规模车队，落地30多个城市
            </div>
            <div class="progress-year">2017年</div>
            <img src="../assets/circle.png" alt="" />
          </div>
        </el-col>
        <el-col :span="8">
          <div class="progress">
            <div class="progress-title">合作100+经销商</div>
            <div class="progress-p">
              以优质运力为核心点，打造新型的司机管理模式，
              快速发展优质的合作运营商，已合作100多个经销商。
            </div>
            <div class="progress-year">2019年</div>
            <img src="../assets/circle.png" alt="" />
          </div>
        </el-col>
        <el-col :span="8">
          <div class="progress">
            <div class="progress-title">建立行业标准</div>
            <div class="progress-p">
              020年起，我们期望整合渠道资源，开放平台合作，
              扩大规模，实现全平台优质运力的推广和准入，
              完善司机管理模式，建立行业标准。
            </div>
            <div class="progress-year">2020年</div>
            <img src="../assets/circle.png" alt="" />
          </div>
        </el-col>
        <div class="time-line"></div>
      </el-row>
    </div>
    <div style="background: #f7f7f8;padding-top:50px">
      <div class="title-box">
        <div class="title">LLP合作方案</div>
      </div>
      <div class="content-center">
        <img
          class="cooperativeSchemeImg"
          src="../assets/cooperativeScheme.png"
          alt=""
        />
      </div>
    </div>

    <div class="content-center">
      <div class="title-box">
        <div class="title">LLP加入理由</div>
      </div>
      <img class="cooperativeSchemeImg" src="../assets/addReason.png" alt="" />
    </div>
    <div class="slide-two">
      <div class="content-center" style="padding-top: 30px">
        <div class="title-box title-white">
          <div class="title">加入LLP</div>
        </div>
        <div class="addllp">
          <div class="addllp-p">
            如您想加入货拉拉LLP，请留下您的联系方式，我们将安排工作人员与您联系，请您耐心等待！
          </div>
          <div class="addllp-form-warp">
            <div class="addllp-input-warp">
              <input
                type="text"
                placeholder="您的姓名"
                v-model="ruleForm.name"
              />
            </div>
            <div class="addllp-input-warp">
              <input
                type="text"
                placeholder="您的联系方式"
                v-model="ruleForm.mobile"
              />
            </div>
            <div class="addllp-btn" @click="submitForm">立即提交</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
      ruleForm: {
        name: '',
        mobile: ''
      }
    }
  },
  methods: {
    addLLP () {
      var t = document.getElementById('app').clientHeight;
      window.scroll({ top: t, left: 0, behavior: 'smooth' });
    },
    checkMobile () {
      if(!this.ruleForm.mobile){
        this.$message.error('请输入手机号');
        return false;
      }else if (!/^1[3|4|5|6|7|8|9]\d{9}$/.test(this.ruleForm.mobile)) {
        this.$message.error('您的手机号码输入有误！');
        return false
      }
      return true;
    },
    getEnv(){
      if(location.host.indexOf('localhost') > -1 || location.host.indexOf('www-stg') > -1){
        return 'https://oms-stg.huolala.cn'
      }
      if(location.host.indexOf('www-pre') > -1){
        return 'https://oms-pre.huolala.cn'
      }
      if(location.host === 'www.huolalazuche.cn'){
        return 'https://oms.huolala.cn'
      }
    },
    async submitForm () {
      if(!this.checkMobile()){
        return ;
      }
      const { mobile, name } = this.ruleForm;
      const url = this.getEnv()+'/api/sale/scExInter/insertSaleclueForEx.do'
      await axios.get(url,{
        params:{
          comName:'',
          mobile,
          sources: 'hll-buy-car-pc',
          clueFrom: '拉拉买车官网',
          clueFromCode: 'GW-LLMC',
          realName: name
        }
      })
      this.$message.success('您已经预约成功，请耐心等待销售顾问联系哦！');
      this.ruleForm = {
        name: '',
        mobile: '',
      }
      this.closeDialog()
    },
    // 关闭弹窗
    closeDialog () {
      this.dialogVisible = false
    },
  },

}
</script>

<style lang="scss" scoped>
.slide-one {
  height: 520px;
  background: url(../assets/llpBanner.png) no-repeat center;
  background-size: auto 100%;
  position: relative;
  .title {
    font-size: 44px;
    font-weight: 600;
    color: #ffffff;
    line-height: 66px;
    padding: 100px 0 36px;
    text-align: center;
  }
  .btn-warp {
    text-align: center;
  }
  .btn {
    display: inline-block;
    width: 140px;
    height: 38px;
    background: #f16622;
    border-radius: 2px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 38px;
    text-align: center;
    margin-bottom: 40px;
  }
  .p-warp {
    display: inline-block;
    width: 671px;
    height: 104px;
    position: relative;
    padding: 10px 27px;
    box-sizing: border-box;
    text-align: left;
    .p-bg {
      position: absolute;
      top: 0;
      left: 0;
      background: #ffffff;
      width: 100%;
      height: 100%;
      opacity: 0.2;
    }
  }
  .p {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 18px;
    margin-bottom: 10px;
  }
}
.content-center {
  width: 1080px;
  margin: 0 auto;
  padding: 10px 50px;
}

.title-white.title-box {
  .title {
    color: #fff !important;
  }
}
.title-box::before {
  content: "";
  display: block;
  position: absolute;
  background: #f16622;
  width: 85px;
  height: 2px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.title-box {
  margin: 30px 0;
  position: relative;
  text-align: center;
  height: 66px;
  .title {
    font-size: 30px;
    font-weight: 600;
    color: #2f3439;
    line-height: 66px;
  }
}
.progress {
  text-align: center;
  position: relative;
  margin-top: 80px;
  .progress-title {
    font-size: 14px;
    color: #2f3439;
    line-height: 18px;
    margin-bottom: 13px;
  }
  .progress-p {
    height: 100px;
    font-size: 12px;
    color: #768191;
    line-height: 18px;
  }
  .progress-year {
    font-size: 18px;
    font-weight: 500;
    color: #2f3439;
    line-height: 18px;
    position: absolute;
    top: 156px;
    left: 50%;
    transform: translateX(-50%);
  }
  img {
    position: absolute;
    width: 22px;
    height: 22px;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
  }
}
.time-line {
  // width: 100%;
  margin: 0 50px 100px;
  height: 1px;
  background: #ffd1ba;
  clear: both;
}
.cooperativeSchemeImg {
  width: 100%;
}
.slide-two {
  height: 420px;
  margin: 36px 0 0;
  background: url(../assets/llpaddbg.png) no-repeat center;
  background-size: auto 100%;
}
.addllp {
  text-align: center;
  .addllp-p {
    margin-top: 42px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
  }
  input {
    width: 284px;
    height: 32px;
    line-height: 32px;
    background: #f7f7f8;
    border-radius: 2px;
    padding: 0 9px;
    border: 0;
    margin-bottom: 20px;

    outline: none;
  }
  .addllp-form-warp {
    margin-top: 49px;
    display: inline-block;
    width: 284px;
  }
  .addllp-btn {
    width: 130px;
    height: 32px;
    background: #f16622;
    border-radius: 2px;
    font-size: 12px;
    text-align: center;
    color: #ffffff;
    line-height: 32px;
  }
}
</style>